<template>
  <svg width="103px" height="27px" viewBox="0 0 103 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <rect id="path-1" x="0" y="0" width="103" height="27" rx="3.3264"></rect>
    </defs>
    <g id="Hi-Fi-Spec" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Callout" transform="translate(-498.000000, -3236.000000)">
        <g id="Apple-Maps-Icon" transform="translate(498.000000, 3236.000000)">
          <g id="Rectangle-12">
            <use fill="#000000" fill-rule="evenodd" xlink:href="#path-1"></use>
            <rect stroke="#979797" stroke-width="0.77" x="0.385" y="0.385" width="102.23" height="26.23" rx="3.3264"></rect>
          </g>
          <path d="M19.6932078,12.9784067 C19.6736473,10.8139415 21.473215,9.76092208 21.5555041,9.71189758 C20.5363336,8.23243218 18.9566531,8.03029006 18.401539,8.01417242 C17.0747963,7.87515774 15.787849,8.80460854 15.1119994,8.80460854 C14.4226597,8.80460854 13.3819052,8.02760379 12.2602106,8.05043712 C10.8167792,8.07259888 9.46642893,8.90467224 8.72582721,10.19677 C7.19740874,12.8313332 8.33731484,16.7029256 9.80165575,18.8324693 C10.5341635,19.8754152 11.3901048,21.039915 12.5104504,20.9989493 C13.6065139,20.9539542 14.0159358,20.3032043 15.3386316,20.3032043 C16.6491863,20.3032043 17.0336517,20.9989493 18.1762558,20.9727581 C19.3525849,20.9539542 20.0931867,19.9251113 20.8000633,18.8727634 C21.6465617,17.6773715 21.98651,16.5001119 22,16.4396708 C21.9723455,16.4302688 19.7154663,15.5726758 19.6932078,12.9784067 Z" id="Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
          <text id="Apple-Maps" font-family="SFProDisplay-Bold, SF Pro Display" font-size="12.474" font-weight="bold" fill="#FFFFFF">
            <tspan x="27" y="19">Apple Maps</tspan>
          </text>
          <path d="M17.2238801,6.77634407 C17.7324823,6.03422031 18.0804733,5.02457892 17.9838738,4 C17.2477391,4.03802281 16.3271342,4.5941064 15.7970007,5.31993467 C15.3279694,5.95953265 14.9089836,7.00787582 15.0172216,7.99375296 C15.8441366,8.0657247 16.6931648,7.5069252 17.2238801,6.77634407 Z" id="Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "apple-maps-icon"
}
</script>

<style scoped>

</style>
